/* src/app/chat-widgets/task-card/task-card.component.css */
:host {
  display: block;
  margin-bottom: 1rem;
}
.p-card {
  border: 1px solid var(--surface-d);
  border-radius: 6px;
}
.p-card-title {
  font-size: 1.25rem;
  font-weight: 600;
}
.task-description {
  font-style: italic;
  color: var(--text-color-secondary);
}
/*# sourceMappingURL=task-card.component-DZC3PICA.css.map */
